import { getIsPermittedWithAnyOfThesePermissions, getIsPermittedWithNoneOfThesePermissions } from '../common/classes/permissions';
const checkCabinetPermissions = (cabinet, user) => {
  const _cabinet$denyPermissi = cabinet.denyPermissions,
    denyPermissions = _cabinet$denyPermissi === void 0 ? [] : _cabinet$denyPermissi,
    _cabinet$allowPermiss = cabinet.allowPermissions,
    allowPermissions = _cabinet$allowPermiss === void 0 ? [] : _cabinet$allowPermiss;
  // Check deny permissions first
  if (denyPermissions.length > 0) {
    if (!getIsPermittedWithNoneOfThesePermissions(denyPermissions, user)) {
      return false;
    }
  }
  // Check allow permissions
  if (allowPermissions.length > 0) {
    return getIsPermittedWithAnyOfThesePermissions(allowPermissions, user);
  }
  // If no specific permissions defined, allow by default
  return true;
};
export default checkCabinetPermissions;